import { useState } from "react";
import { motion, useScroll, useMotionValueEvent } from "framer-motion";
import { scrollToId } from "@/lib/api";

const LINKS = [
  { id: "espaco", label: "O Espaço" },
  { id: "galeria", label: "Galeria" },
  { id: "comodidades", label: "Comodidades" },
  { id: "disponibilidade", label: "Disponibilidade" },
  { id: "comentarios", label: "Comentários" },
  { id: "contactos", label: "Contactos" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const { scrollY } = useScroll();
  useMotionValueEvent(scrollY, "change", (v) => setScrolled(v > 40));

  return (
    <motion.header
      data-testid="main-navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-40 transition-[background-color,box-shadow] duration-500 ${
        scrolled ? "bg-cream/90 backdrop-blur-xl shadow-[0_1px_0_#E8E5E1]" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <button
          data-testid="nav-logo"
          onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
          className="font-display text-lg tracking-tight text-ink transition-colors duration-500"
        >
          Queluz <span className="text-clay">Cardoso</span>
        </button>
        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollToId(l.id)}
              className={`text-sm tracking-wide transition-colors duration-300 hover:text-clay ${
                "text-ink/70"
              }`}
            >
              {l.label}
            </button>
          ))}
        </nav>
        <button
          data-testid="nav-book-btn"
          onClick={() => scrollToId("reservar")}
          className="rounded-full bg-clay px-6 py-2.5 text-sm font-medium text-cream transition-[transform,background-color] duration-300 hover:scale-[1.04] hover:bg-clay-dark"
        >
          Reservar
        </button>
      </div>
    </motion.header>
  );
};
